<svelte:options tag={null} />
  <script>
  export let id = undefined;
  export let style = undefined;
  export let className = undefined;
  export let fill = undefined;
  export let size = "3rem";
</script>

<svg aria-hidden="true" width={size} height={size} id={id}  style={style} class={className} fill={fill} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48"><path d="M22.52 12.41L5.14 31.66A2 2 0 006.62 35h34.76a2 2 0 001.48-3.34L25.48 12.41a2 2 0 00-2.96 0zm1 12.27L9.8 31l13.7-15.21zm.5.87L38 32H10zm.5-.87v-8.89L38.2 31z"/></svg>